import t from"./worker";function e(){const e=new Blob([t],{type:"text/javascript"});return URL.createObjectURL(e)}export{e as getWorkerURL};
